var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLandingBpShadow = function SvgLandingBpShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M540 0H10C4.477 0 0 4.477 0 10v180c0 5.523 4.477 10 10 10h530c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10Z",
    fill: "url(#LandingBPShadow_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "LandingBPShadow_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(65.356 163.977 111.558) scale(344.145 887.162)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
};
export default SvgLandingBpShadow;